import { getProcessColor, getProcessLabel } from '../lib/taxonomy'

interface ProcessBadgeProps {
  code: string
  size?: 'xs' | 'sm'
}

export function ProcessBadge({ code, size = 'xs' }: ProcessBadgeProps) {
  const color = getProcessColor(code)
  const label = getProcessLabel(code)
  const sizeClass =
    size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-[10px] px-1.5 py-0.5'
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${sizeClass}`}
      style={{
        borderColor: color,
        backgroundColor: `${color}26`,
        color,
      }}
      title={code}
    >
      {label}
    </span>
  )
}
